import {
    useQueryClient,
} from '@tanstack/react-query'
import {
    useCallback,
} from 'react'

import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import config from 'app/requests/Container/Container.requests'
import {
    Container,
} from '../containers.types'

const useGetContainerBySerialNumber = (
    serialNumber: string,
) => {
    const queryClient = useQueryClient()

    const invalidate = useCallback(() => {
        queryClient.invalidateQueries({
            queryKey: [RequestKeys.getContainerBySerialNumber],
        })
    }, [queryClient])

    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
    } = useRequest<Container>({
        key: RequestKeys.getContainerBySerialNumber,
        params: {
            serialNumber,
        },
        requestFunc: RequestFn.getEntity(config[RequestKeys.getContainerBySerialNumber]),
        enabled: Boolean(serialNumber),
    })

    return {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    }
}

export default useGetContainerBySerialNumber
